<template>
  <div>
    <div class="vh-100 bg-grey" v-if="!pageSetting.loading.import && !pageSetting.loading.export">
      <SOTitleBar
          :page-title="'Konsumen'"
          :type="'back'"
          :show-search="true"
          v-if="!(isSearch || isSearchCustomerGlobal)"
          @search="() => { nav.selected === 'reguler' ? search() : searchCustomerGlobal() }"
          @back="toDashboard"
          style="border-bottom: none"
      />
      <SOSearchBar
          v-if="isSearch"
          :value="searchKey.key"
          :context="'Konsumen'"
          :data-count="pageSetting.loading.list ? 0 : customerData.data !== undefined ? customerData.data.length : 0"
          :waiting="pageSetting.search.waiting"
          :search-information="'Nama konsumen dan nomor telepon konsumen'"
          @return-search-value="(v) => { searchKey.key = v }"
          @loading="loadingSearch"
          @close="closeSearch"
          @do-search="doSearchCustomer"
      />
      <SOSearchBar
          v-if="isSearchCustomerGlobal"
          :value="searchKeyCustomerGlobal.key"
          :context="'Konsumen Snapclean'"
          :data-count="pageSetting.loading.list ? 0 : customerGlobalData.data !== undefined ? customerGlobalData.data.length : 0"
          :waiting="pageSetting.search.waiting"
          :search-information="'Nama konsumen dan nomor telepon konsumen'"
          @return-search-value="(v) => { searchKeyCustomerGlobal.key = v }"
          @loading="loadingSearch"
          @close="closeSearchCustomerGlobal"
          @do-search="doSearchCustomerGlobal"
      />

      <div class="content-wrapper customer-content"
           :class="{'main-page-tab' : !(isSearch || isSearchCustomerGlobal)}">
        <SOTab
            :menus="nav.menus"
            :selected="nav.selected"
            v-if="!(isSearch || isSearchCustomerGlobal)"
            @selected="selectedNav"
        />

        <SOExportProgressMinimized
            v-if="pageSetting.minimizedExport.reguler && nav.selected === 'reguler'"
            :processed-data="exportProgress.reguler.processed"
            :total-data="exportProgress.reguler.total"
            :context="'konsumen reguler'"
            :tracker-actions="'customerModule/exportTrack'"
            @on-success="checkExport"
            @on-error="() => { pageSetting.minimizedExport.reguler = false }"
        />

        <SOExportProgressMinimized
            v-if="pageSetting.minimizedExport.snapclean && nav.selected === 'snapclean'"
            :processed-data="exportProgress.snapclean.processed"
            :total-data="exportProgress.snapclean.total"
            :context="'konsumen snapclean'"
            :tracker-actions="'customerGlobalModule/exportTrack'"
            @on-success="checkExport"
            @on-error="() => { pageSetting.minimizedExport.snapclean = false }"
        />

        <SOExportMultipleFile
            v-if="pageSetting.multipleExport.reguler && !pageSetting.minimizedExport.reguler"
            :export-data="exportData.reguler"
            :export-data-length="exportDataLength.reguler"
            :delete-cluster-actions="'customerModule/exportDeleteCluster'"
            :delete-master-actions="'customerModule/exportDeleteMaster'"
            @downloaded="(index) => { exportData.reguler[index].downloaded = true }"
            @done="() => { pageSetting.multipleExport.reguler = false; exportData.reguler = [] }"
        />

        <SOExportMultipleFile
            v-if="pageSetting.multipleExport.snapclean && !pageSetting.minimizedExport.snapclean"
            :export-data="exportData.snapclean"
            :export-data-length="exportDataLength.snapclean"
            :delete-cluster-actions="'customerGlobalModule/exportDeleteCluster'"
            :delete-master-actions="'customerGlobalModule/exportDeleteMaster'"
            @downloaded="(index) => { exportData.snapclean[index].downloaded = true }"
            @done="() => { pageSetting.multipleExport.snapclean = false; exportData.snapclean = [] }"
        />

        <div class="p-x-20 p-y-16 w-limit" v-if="pageSetting.loading.list">
          <SOCardCustomerSkeleton/>
        </div>

        <!--<div class="p-x-20 p-t-16 p-d-72 w-limit" v-else>-->
        <div class="p-x-20 p-t-16 w-limit" v-else>
          <div v-if="validateAccess('customerRegular.read')" :class="{'hide': nav.selected !== 'reguler'}">
            <div class="bg-yellow p-x-20 p-y-8 d-flex" style="margin: -12px -20px 20px" v-if="!isSearch && customerData.data.length !== 0">
              <img src="@/assets/icons/alert-circle-yellow.svg" alt="" class="m-r-12">
              <div class="d-block">
                <div class="f-semi f-c-black f-14">
                  Template Data Konsumen telah diperbarui pada tanggal 03 Agustus 2021 17:00
                </div>
                <div class="f-regular f-c-midgrey f-12">
                  Pastikan Anda menggunakan template terbaru sebelum meng-unggah data untuk di import.
                </div>
              </div>
            </div>
            <div class="bg-white f-regular f-12 f-c-midgrey"
                 style="padding: 8px 18px; margin: -16px -18px 16px"
                 v-if="!isSearch"
            >
              Data ini dibuat dari Smartlink Owner & Smartlink Kasir
            </div>
            <SOEmptyState
                v-if="customerData.data !== undefined && customerData.data.length === 0 && !isSearch"
                :message="'Belum ada konsumen terdaftar'"
                :sub-message="'Klik tombol + untuk menambahkan'"
            />
            <SOEmptySearchState
                v-if="isSearch && !pageSetting.loading.list && !pageSetting.search.waiting && customerData.lengthData === 0 && searchKey.key.length > 1"
                @action="() => { resetFilter(); searchKey.key = '' }"
            />

            <SOHeaderList
                v-if="customerData.data !== undefined"
                :title="customerData.data.length === 0 ? '' : titleHeaderListCustomer()"
                :show-filter="true"
                @filter="showFilterCustomer"
            />

            <SOCardCustomer
                v-if="customerData.data.length > 0"
                v-for="customer in customerData.data"
                :keySearch="searchKey.key"
                :isSearch="isSearch"
                :key="customer.idcustomer"
                :customer="customer"
                :filter-saldo-epayment="isFilterSaldoEpayment"
                @detail="(e) => { detailCustomer(e, customer.idcustomer) }"
            />

            <SOLoadMoreLoading
                v-if="customerData.lengthData > 0"
                :id="'loading-customer'"
                :loading="pageSetting.loading.loadMore"
            />
          </div>
          <div :class="{'hide': nav.selected !== 'snapclean'}">
            <div class="bg-white f-regular f-12 f-c-midgrey"
                 style="padding: 8px 18px; margin: -16px -18px 16px"
                 v-if="!isSearchCustomerGlobal"
            >
              Data ini dibuat dari konsumen yang terdaftar di aplikasi SnapClean, serta dari Smartlink
              Kasir (Drop Off)
            </div>

            <SOEmptyState
                v-if="customerGlobalData.data !== undefined && customerGlobalData.data.length === 0 && !isSearchCustomerGlobal"
                :message="'Belum ada konsumen terdaftar'"
                :sub-message="'Penambahan konsumen Snapclean tidak bisa melalui Smartlink Owner.'"
            />
            <SOEmptySearchState
                v-if="isSearchCustomerGlobal && !pageSetting.loading.list && !pageSetting.search.waiting && customerGlobalData.lengthData === 0 && searchKeyCustomerGlobal.key.length > 1"
                @action="() => { resetFilter(); searchKeyCustomerGlobal.key = '' }"
            />

            <SOHeaderList
                v-if="customerGlobalData.data !== undefined"
                :title="customerGlobalData.data.length === 0 ? '' : titleHeadetListCustomerGlobal()"
                :show-filter="true"
                @filter="showFilterCustomer"
            />

            <SOCardCustomerGlobal
                v-if="customerGlobalData.data.length > 0"
                v-for="customer in customerGlobalData.data"
                :keySearch="searchKeyCustomerGlobal.key"
                :isSearch="isSearchCustomerGlobal"
                :key="customer.idcustomer"
                :customer="customer"
                @detail="(e) => { detailCustomerGlobal(e, customer.idcustomer) }"
            />

            <SOLoadMoreLoading
                v-if="customerGlobalData.lengthData > 0"
                :id="'loading-customer-global'"
                :loading="pageSetting.loading.loadMore"
            />
          </div>
        </div>
      </div>

      <SOFABMenu
          v-if="!isSearch && nav.selected === 'reguler'"
          :context="'Konsumen'"
          @action="createCustomer"
          @import="() => { pageSetting.modal.import = true }"
          @export="() => { pageSetting.modal.export.reguler = true }"
      />
      <!--<SOFABMenu-->
      <!--	v-if="!isSearch && nav.selected === 'reguler'"-->
      <!--	:context="'Konsumen'"-->
      <!--	@action="createCustomer"-->
      <!--	@import="() => { pageSetting.modal.import = true }"-->
      <!--	@export="() => { $toast.warning('Fitur Sedang dalam perbaikan') }"-->
      <!--/>-->

      <SOFABExport
          v-if="isSearch && nav.selected === 'reguler'"
          @export="() => { pageSetting.modal.export.reguler = true }"
      />
      <SOFABExport
          v-if="nav.selected === 'snapclean'"
          @export="() => { pageSetting.modal.export.snapclean = true }"
      />

      <SOFilter
          v-if="pageSetting.showFilter"
          :filter-konsumen="pageSetting.showFilter && nav.selected === 'reguler'"
          :filter-konsumen-snapclean="pageSetting.showFilter && nav.selected === 'snapclean'"
          :sorting="nav.selected === 'snapclean' ? sorting.filter(v => v.all === true) : sorting"
          @back="hideFilterCustomer"
          @do-filter="doFilter"
          @reset-filter="resetFilter"
      />

      <SOModalImport
          v-if="pageSetting.modal.import"
          :context="'Konsumen'"
          :url-import-template="urlImportTemplate"
          @import-process="importCustomer"
          @close="() => { pageSetting.modal.import = false }"
      />

      <SOModalExport
          v-if="pageSetting.modal.export.reguler"
          :is-running="pageSetting.minimizedExport.reguler"
          :context="'Konsumen'"
          :total-data="customerData.lengthData  + ' Konsumen'"
          :export-data-exist="exportData.reguler.length > 0 ? exportData.reguler.filter(v => v.downloaded === false).length : 0"
          @close="() => { pageSetting.modal.export.reguler = false }"
          @do-export="exportCustomer"
      />

      <SOModalExport
          v-if="pageSetting.modal.export.snapclean"
          :is-running="pageSetting.minimizedExport.snapclean"
          :context="'Konsumen SnapClean'"
          :total-data="customerGlobalData.lengthData  + ' Konsumen SnapClean'"
          :export-data-exist="exportData.snapclean.length > 0 ? exportData.snapclean.filter(v => v.downloaded === false).length : 0"
          @close="() => { pageSetting.modal.export.snapclean = false }"
          @do-export="exportCustomer"
      />
    </div>

    <SOImportProgress
        v-if="pageSetting.loading.import"
        :context="'konsumen'"
        :tracker-actions="'customerModule/importCustomerTracker'"
        @on-success="importOnSuccess"
        @on-error="() => { pageSetting.loading.import = false }"
        @on-duplicate="importOnDuplicate"
    />
    <CustomerModalNamaDuplikat
        v-if="pageSetting.modal.duplicatedName"
        :list-duplicate="listCustomerDuplicate"
        @close="() => { pageSetting.modal.duplicatedName = false }"
        @force-import="importCustomerForce"
    />

    <SOExportProgress
        v-if="pageSetting.loading.export"
        :context="'konsumen ' + nav.selected"
        :tracker-actions="nav.selected === 'reguler' ? 'customerModule/exportTrack' : 'customerGlobalModule/exportTrack'"
        @on-success="checkExport"
        @on-error="() => { pageSetting.loading.export = false }"
        @minimized-export="minimizedExport"
    />
  </div>
</template>

<script>
import {mapGetters} from "vuex"

import SOTitleBar from "@/so-components/global/ui/SOTitleBar";
import SOTab from "@/so-components/global/ui/SOTab";
import SOExportProgressMinimized from "@/so-components/global/ui/SOExportProgressMinimized";
import SOCardCustomer from "@/so-components/modules/customer/SOCardCustomer.vue";
import SOCardCustomerGlobal from "@/so-components/modules/customer-global/SOCardCustomerGlobal";
import SOEmptyState from "@/so-components/global/ui/SOEmptyState";
import SOEmptySearchState from "@/so-components/global/ui/SOEmptySearchState";
import SOFilter from "@/so-components/global/filter/base/SOFilter";
import SOFABRegular from "@/so-components/global/ui/SOFABRegular";
import SOFABMenu from "@/so-components/global/ui/SOFABMenu";
import SOFABExport from "@/so-components/global/ui/SOFABExport";
import SOCardCustomerSkeleton from "@/so-components/modules/customer/SOCardCustomerSkeleton";
import SOHeaderList from "@/so-components/global/ui/SOHeaderList";
import SOSearchBar from "@/so-components/global/ui/SOSearchBar";
import SOLoadMoreLoading from "@/so-components/global/ui/SOLoadMoreLoading";
import SOModalImport from "@/so-components/global/modal/SOModalImport";
import SOImportProgress from "@/so-components/global/ui/SOImportProgress";
import SOExportProgress from "@/so-components/global/ui/SOExportProgress";
import SOExportMultipleFile from "@/so-components/global/ui/SOExportMultipleFile";

import CustomerModalNamaDuplikat from "./modal/CustomerModalNamaDuplikat";
import SOModalExport from "@/so-components/global/modal/SOModalExport";

export default {
  name: "Customer",
  components: {
    SOModalExport,
    SOTitleBar,
    SOTab,
    SOExportProgressMinimized,
    SOCardCustomer,
    SOCardCustomerGlobal,
    SOEmptyState,
    SOEmptySearchState,
    SOFilter,
    SOFABRegular,
    SOFABMenu,
    SOFABExport,
    SOCardCustomerSkeleton,
    SOHeaderList,
    SOSearchBar,
    SOLoadMoreLoading,
    SOModalImport,
    SOImportProgress,
    SOExportProgress,
    SOExportMultipleFile,

    CustomerModalNamaDuplikat,
  },
  computed: {
    ...mapGetters("customerModule", {
      customerData: "getCustomer",
      pagination: "getPagination",
      isSearch: "getIsSearchCustomer",
      searchKey: "getSearch",
      scrollPosition: "getScrollPosition"
    }),
    ...mapGetters("customerGlobalModule", {
      customerGlobalData: "getCustomerGlobal",
      paginationCustomerGlobal: "getPagination",
      isSearchCustomerGlobal: "getIsSearchCustomerGlobal",
      searchKeyCustomerGlobal: "getSearch",
      scrollPositionCustomerGlobal: "getScrollPosition"
    }),
    ...mapGetters("filterGlobalModule", {
      filter: "getFilter",
      filterItem: "getFilterItem",
    }),
    isFilterSaldoEpayment() {
      return this.filterItem.filterSaldoEpayment.minimal > 0 || this.filterItem.filterSaldoEpayment.maksimal > 0
    },
  },
  data() {
    return {
      urlImportTemplate: "https://storage.googleapis.com/ember-e-dalbo/bos_revamp/master_template_excel/template_data_konsumen_v2.xlsx",
      fileExcel: null,
      listCustomerDuplicate: [],
      exportProgress: {
        reguler: {
          processed: 0,
          total: 0,
        },
        snapclean: {
          processed: 0,
          total: 0,
        }
      },

      sorting: [
        {
          label: "Abjad A-Z",
          name: "sorting",
          value: JSON.stringify({
            sortBy: "abjad",
            orderBy: "ASC",
          }),
          id: "sorting-1",
          all: true,
        },
        {
          label: "Abjad Z-A",
          name: "sorting",
          value: JSON.stringify({
            sortBy: "abjad",
            orderBy: "DESC",
          }),
          id: "sorting-2",
          all: true,
        },
        {
          label: "Transaksi terbaru",
          name: "sorting",
          value: JSON.stringify({
            sortBy: "transaksi_terakhir",
            orderBy: "DESC",
          }),
          id: "sorting-3",
          all: true,
        },
        {
          label: "Transaksi terlama",
          name: "sorting",
          value: JSON.stringify({
            sortBy: "transaksi_terakhir",
            orderBy: "ASC",
          }),
          id: "sorting-4",
          all: true,
        },
        {
          label: "Transaksi terbanyak",
          name: "sorting",
          value: JSON.stringify({
            sortBy: "banyak_transaksi",
            orderBy: "DESC",
          }),
          id: "sorting-5",
          all: true,
        },
        {
          label: "Transaksi terendah",
          name: "sorting",
          value: JSON.stringify({
            sortBy: "banyak_transaksi",
            orderBy: "ASC",
          }),
          id: "sorting-6",
          all: true,
        },
        {
          label: "Nominal transaksi terbesar",
          name: "sorting",
          value: JSON.stringify({
            sortBy: "nominal_transaksi",
            orderBy: "DESC",
          }),
          id: "sorting-7",
          all: false,
        },
        {
          label: "Nominal transaksi terkecil",
          name: "sorting",
          value: JSON.stringify({
            sortBy: "nominal_transaksi",
            orderBy: "ASC",
          }),
          id: "sorting-8",
          all: false,
        },
      ],

      nav: {
        menus: [
          {
            id: "reguler",
            title: "Reguler",
            accessKey: "customerRegular.read",
          },
          {
            id: "snapclean",
            title: "SnapClean",
            accessKey: "snapClean.read",
          }
        ],
        selected: "reguler"
      },

      pageSetting: {
        showFilter: false,
        loading: {
          list: true,
          loadMore: false,
          import: false,
          export: false,
        },
        modal: {
          import: false,
          export: {
            reguler: false,
            snapclean: false,
          },
          duplicatedName: false,
        },
        search: {
          waiting: false,
        },
        error: {
          list: false,
        },
        minimizedExport: {
          reguler: false,
          snapclean: false,
        },
        multipleExport: {
          reguler: false,
          snapclean: false,
        }
      },

      exportData: {
        reguler: [],
        snapclean: [],
      },
      exportDataLength: {
        reguler: 0,
        snapclean: 0,
      },
      idmaster_member: [],
    }
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      let query = vm.$route.query
      if (query.idmaster_member !== undefined) {
        vm.idmaster_member = [query.idmaster_member]
      }
      if (from.path.split("/")[1] !== "konsumen") {
        vm.initCustomer(query)
      } else {
        vm.pageSetting.loading.list = false
        vm.nav.selected = vm.$route.hash.replace("#", "")
        if (vm.customerData.data === undefined) {
          vm.initCustomer(query)
          return
        }
        if (vm.$route.hash === "#snapclean") {
          vm.setDefaultFilterSnapclean(query, true)
        } else {
          vm.setDefaultFilterRegular(query, true)
        }
        setTimeout(() => {
          vm.nav.selected === "reguler" ?
              window.scrollTo(0, vm.scrollPosition) :
              window.scrollTo(0, vm.scrollPositionCustomerGlobal)
        }, 5)
      }
    })
  },
  async mounted() {
    // await this.initCustomer()
    this.scroll()
    this.smartTrackingView("list_konsumen");

  },
  methods: {
    toDashboard() {
      this.$router.push("/dashboard")
    },

    async listCustomer() {
      if (!this.pageSetting.loading.list) {
        this.pageSetting.loading.loadMore = true
      }
      if (this.customerData.data !== undefined && this.customerData.data.lenght === 0) {
        this.pageSetting.search.waiting = true
      }
      if (!this.validateAccess("customerRegular.read")) {
        document.getElementById('snapclean').click()
        return
      }
      let temp = this.filterItem
      this.$store.commit("filterGlobalModule/setFilterItem", temp)

      const res = await this.$store.dispatch("customerModule/fetchCustomerV2")
      this.pageSetting.loading.list = false;
      this.pageSetting.loading.loadMore = false
      this.pageSetting.search.waiting = false;
      this.$store.commit("helper/setScrollCalled", false)
      if (res.success) {
        this.pageSetting.error.list = false
        await this.$store.commit("customerModule/setNextPagination", {data: this.customerData.data})
      } else {
        this.pageSetting.error.list = true
        setTimeout(() => {
          this.pageSetting.error.list = false
        }, 10000)
        this.$toast.error(res.err)
      }
      window.location.hash = "reguler"
    },
    async listCustomerGlobal() {
      if (!this.pageSetting.loading.list) {
        this.pageSetting.loading.loadMore = true
      }
      const res = await this.$store.dispatch("customerGlobalModule/fetchCustomerGlobal")
      this.pageSetting.loading.list = false;
      this.pageSetting.loading.loadMore = false
      this.$store.commit("helper/setScrollCalled", false)
      if (res.success) {
        this.pageSetting.error.list = false
        await this.$store.commit("customerGlobalModule/setNextPagination", {data: this.customerGlobalData.data})
      } else {
        this.pageSetting.error.list = true
        setTimeout(() => {
          this.pageSetting.error.list = false
        }, 10000)
        this.$toast.error(res.err)
      }
      window.location.hash = "snapclean"
    },
    async doSearchCustomer(search) {
      await this.resetListData()
      await this.$store.commit("customerModule/setSearch", search)
      await this.listCustomer()
      this.pageSetting.search.waiting = false
    },
    async doSearchCustomerGlobal(search) {
      await this.resetListDataCustomerGlobal()
      await this.$store.commit("customerGlobalModule/setSearch", search)
      await this.listCustomerGlobal()
      this.pageSetting.search.waiting = false
    },
    createCustomer() {
      this.$router.push("/konsumen/create/1")
    },
    detailCustomer(e, id) {
      this.$store.commit("customerModule/setScrollPosition", e.pageY)
      this.$router.push("/konsumen/detail/" + id)
      this.smartTrackingClick("detail_konsumen_reguler");

    },
    detailCustomerGlobal(e, id) {
      this.$store.commit("customerGlobalModule/setScrollPosition", e.pageY)
      this.$router.push("/konsumen/snapclean/detail/" + id)
      this.smartTrackingClick("detail_konsumen_snapclean");
    },
    async selectedNav(selected) {
      this.nav.selected = selected;
      this.pageSetting.loading.list = true

      // await this.$store.commit("filterGlobalModule/resetFilterItem") // comment this if needed
      this.resetFilter()
      await this.checkExport()

      if (selected === "reguler") {
        await this.resetListData()
        this.smartTrackingClick("list_konsumen_reguler");
        await this.listCustomer()
        this.smartTrackingView("list_konsumen_reguler");

      } else {
        await this.resetListDataCustomerGlobal()
        this.smartTrackingClick("list_konsumen_snapclean");
        await this.listCustomerGlobal()
        this.smartTrackingView("list_konsumen_snapclean");
      }

      setTimeout(() => {
        window.scrollTo(0, 0)
      }, 1)
    },

    titleHeaderListCustomer() {
      let strTotal = this.isSearch ? '' : 'Total '
      if (this.isSearch && this.searchKey.key.length < 2) {
        return ''
      } else {
        if (this.customerData.data !== undefined) {
          return strTotal + this.formatRupiah(this.customerData.lengthData) + ' Konsumen'
        } else {
          return strTotal + '0 Konsumen'
        }
      }
    },
    titleHeadetListCustomerGlobal() {
      let strTotal = this.isSearchCustomerGlobal ? '' : 'Total '
      if (this.isSearchCustomerGlobal && this.searchKeyCustomerGlobal.key.length < 2) {
        return ''
      } else {
        if (this.customerGlobalData.data !== undefined) {
          return strTotal + this.formatRupiah(this.customerGlobalData.lengthData) + ' Konsumen'
        } else {
          return strTotal + '0 Konsumen'
        }
      }
    },

    // import
    async importCustomer(payload) {
      this.pageSetting.modal.import = false
      this.pageSetting.loading.import = true

      this.fileExcel = payload.fileExcel
      let form = {
        force: 0,
        fileExcel: this.fileExcel
      }
      const res = await this.$store.dispatch("customerModule/importCustomer", form)
      if (!res.success) {
        this.pageSetting.loading.import = false
        this.$toast.error(res.err)
      }
    },
    async importCustomerForce() {
      this.pageSetting.modal.duplicatedName = false
      this.pageSetting.loading.import = true

      let form = {
        force: 1,
        fileExcel: this.fileExcel
      }
      const res = await this.$store.dispatch("customerModule/importCustomer", form)
      if (!res.success) {
        this.pageSetting.loading.import = false
        this.$toast.error(res.err)
      }
    },
    async importOnSuccess() {
      this.pageSetting.loading.import = false
      this.fileExcel = null

      await this.resetListData()
      await this.listCustomer()
    },
    importOnDuplicate(data) {
      this.pageSetting.loading.import = false;
      this.pageSetting.modal.duplicatedName = true

      this.listCustomerDuplicate = data.nama_dupicate
    },

    // export
    async exportCustomer() {
      this.pageSetting.loading.export = true

      let res;
      if (this.nav.selected === "reguler") {
        this.pageSetting.modal.export.reguler = false
        res = await this.$store.dispatch("customerModule/export", {
          type: "customer_reguler_export"
        })
      } else if (this.nav.selected === "snapclean") {
        this.pageSetting.modal.export.snapclean = false
        res = await this.$store.dispatch("customerGlobalModule/export", {
          type: "customer_global_export"
        })
      } else {
        this.$toast.error("Silahkan pilih konsumen mana yang ingin anda export")
        return
      }
      if (!res.success) {
        this.pageSetting.loading.export = false
        this.$toast.error(res.err)
      }
    },
    exportOnSuccess(type) {
      this.pageSetting.loading.export = false
      type === "reguler" ? this.pageSetting.minimizedExport.reguler = false
          : this.pageSetting.minimizedExport.snapclean = false
    },
    minimizedExport(data) {
      this.pageSetting.loading.export = false
      if (this.nav.selected === "reguler") {
        this.pageSetting.minimizedExport.reguler = true
        this.exportProgress.reguler.processed = Number(data.processed)
        this.exportProgress.reguler.total = Number(data.total)
      } else {
        this.pageSetting.minimizedExport.snapclean = true
        this.exportProgress.snapclean.processed = Number(data.processed)
        this.exportProgress.snapclean.total = Number(data.total)
      }
    },
    async checkExport() {
      // if (this.nav.selected === "reguler") {
      // 	this.pageSetting.minimizedExport.reguler = false
      // 	const res = await this.$store.dispatch("customerModule/exportCustomerTracker")
      // 	if (res.data.status_progress === "0") {
      // 		this.exportProgress.reguler.processed = Number(res.data.progress_looping)
      // 		this.exportProgress.reguler.total = Number(res.data.length_data)
      // 		this.pageSetting.minimizedExport.reguler = true
      // 	}
      // } else {
      // 	this.pageSetting.minimizedExport.snapclean = false
      // 	const res = await this.$store.dispatch("customerGlobalModule/exportCustomerGlobalTracker")
      // 	if (res.data.status_progress === "0") {
      // 		this.exportProgress.snapclean.processed = Number(res.data.progress_looping)
      // 		this.exportProgress.snapclean.total = Number(res.data.length_data)
      // 		this.pageSetting.minimizedExport.snapclean = true
      // 	}
      // }

      this.pageSetting.loading.export = false
      this.pageSetting.minimizedExport[this.nav.selected] = false
      this.pageSetting.multipleExport[this.nav.selected] = false
      const res = this.nav.selected === "reguler" ?
          await this.$store.dispatch("customerModule/exportTrack") :
          await this.$store.dispatch("customerGlobalModule/exportTrack")
      if (!res.success) {
        return
      }
      this.exportDataLength[this.nav.selected] = res.data.length
      if (res.data.info_data_export.length > 0) {
        if (res.data.status === 1) {
          this.pageSetting.multipleExport[this.nav.selected] = true
          this.exportData[this.nav.selected] = res.data.info_data_export
          this.exportData[this.nav.selected].forEach(v => {
            v["downloaded"] = false
          })
        } else {
          this.pageSetting.minimizedExport[this.nav.selected] = true
        }
      }
    },
    // async deleteFileExport(filename) {
    // 	if (this.nav.selected === "reguler") {
    // 		const res = await this.$store.dispatch("customerModule/deleteExportFileCustomer", filename)
    // 	} else if (this.nav.selected === "snapclean") {
    // 		const res = await this.$store.dispatch("customerGlobalModule/deleteExportFileCustomerGlobal", filename)
    // 	}
    // },

    scroll() {
      window.onscroll = async () => {
        if (this.pageSetting.error.list) {
          return
        }
        let payload = {
          idLoadMore: this.nav.selected === 'reguler' ? "loading-customer" : "loading-customer-global",
          container: "customer-content",
          pagination: this.nav.selected === 'reguler' ? this.pagination : this.paginationCustomerGlobal,
          callback: this.nav.selected === 'reguler' ? this.listCustomer : this.listCustomerGlobal,
        }
        await this.$store.dispatch("helper/scroll", payload)
      }
    },

    // filter
    async initCustomer(query) {
      await this.flushDataCustomer()
      if (!this.validateAccess('customer.customerRegular') && this.validateAccess('customer.customerSnapclean')) {
        document.getElementById('snapclean').click()
        return
      }
      if (this.$route.hash === "#snapclean") {
        await this.setDefaultFilterSnapclean(query)
      } else {
        await this.setDefaultFilterRegular(query)
      }
    },
    async setDefaultFilterRegular(query, state = false) {
      // this.$store.commit("filterGlobalModule/resetFilterItem")
      if (Object.keys(query).length > 0) {
        let filterItem = this.filterItem
        // filterItem.kontakKonsumen = (query.kontak === "all") ? ["true", "false"] : [query.kontak]
        if (query.kontak) filterItem.kontakKonsumen = (Array.isArray(query.kontak)) ? query.kontak : [query.kontak]
        filterItem.periode.filterBy = query.filter_by ?? ''
        if (query.filter_kolom) filterItem.filterRentangTanggalKonsumen = query.filter_kolom
        if (query.tanggal_awal) filterItem.periode.startDate = query.tanggal_awal
        if (query.tanggal_akhir) filterItem.periode.endDate = query.tanggal_akhir
        if (query.bulan) filterItem.periode.month = query.bulan
        if (query.tahun) filterItem.periode.year = query.tahun
        if (query.filter_layanan_by) filterItem.filterLayananOwner = query.filter_layanan_by
        if (query.idlayanan_array) filterItem.layananOwner = (Array.isArray(query.idlayanan_array)) ? query.idlayanan_array : [query.idlayanan_array]
        if (query.iddeposit_array) filterItem.deposit = (Array.isArray(query.iddeposit_array)) ? query.iddeposit_array : [query.iddeposit_array]
        if (query.outlet_array) filterItem.outlet = (Array.isArray(query.outlet_array)) ? query.outlet_array : [query.outlet_array]
        if (query.min_epay) filterItem.filterSaldoEpayment.minimal = query.min_epay
        if (query.max_epay) filterItem.filterSaldoEpayment.minimal = query.max_epay
        if (query.agama) filterItem.agama = (Array.isArray(query.agama)) ? query.agama : [query.agama]
        if (query.idmaster_member) filterItem.idmaster_member = (Array.isArray(query.idmaster_member)) ? query.idmaster_member : [query.idmaster_member]

        await this.$store.commit("filterGlobalModule/setFilterItem", filterItem)

        if (query.key) {
          await this.$store.commit("customerModule/setSearch", query.key)
          await this.$store.commit("customerModule/setIsSearchCustomer", true)
        }

        let temp = this.filter
        temp.sortBy = query.sort_by
        temp.orderBy = query.order_by
        await this.$store.commit("filterGlobalModule/setFilter", temp)
      } else {
        this.resetFilter()
      }

      if (!state) this.$store.commit("customerModule/resetPagination")

      if (!state) await this.selectedNav("reguler")
    },
    async setDefaultFilterSnapclean(query, state = false) {
      // this.$store.commit("filterGlobalModule/resetFilterItem")
      if (Object.keys(query).length > 0) {
        let filterItem = this.filterItem
        if (query.key) {
          await this.$store.commit("customerGlobalModule/setSearch", query.key)
          await this.$store.commit("customerGlobalModule/setIsSearchCustomerGlobal", true)
        }
        if (query.filter_by) filterItem.periode.filterBy = query.filter_by
        if (query.filter_kolom) filterItem.filterRentangTanggalKonsumenSnapclean = query.filter_kolom
        if (query.tanggal_awal) filterItem.periode.startDate = query.tanggal_awal
        if (query.tanggal_akhir) filterItem.periode.endDate = query.tanggal_akhir
        if (query.bulan) filterItem.periode.month = query.bulan
        if (query.tahun) filterItem.periode.year = query.tahun
        if (query.filter_layanan_by) filterItem.filterLayananOwner = query.filter_layanan_by
        if (query.idlayanan_array) filterItem.layananSnapcleanOwner = (Array.isArray(query.idlayanan_array)) ? query.idlayanan_array : [query.idlayanan_array]

        let temp = this.filter
        temp.sortBy = query.sort_by
        temp.orderBy = query.order_by
        await this.$store.commit("filterGlobalModule/setFilter", temp)
      } else {
        this.resetFilter()
      }

      if (!state) this.$store.commit("customerGlobalModule/resetPagination")

      if (!state) await this.selectedNav("snapclean")
    },
    resetFilter() {
      let temp = this.filter
      temp.sortBy = "abjad"
      temp.orderBy = "ASC"
      this.$store.commit("filterGlobalModule/setFilter", temp)
    },
    showFilterCustomer() {
      this.pageSetting.showFilter = true;
    },
    hideFilterCustomer() {
      this.pageSetting.showFilter = false;
    },
    async doFilter() {
      this.pageSetting.showFilter = false
      if (this.isSearch && this.searchKey.key.length < 2) {
        return
      }
      this.pageSetting.loading.list = true
      this.pageSetting.search.waiting = true
      if (this.nav.selected === 'reguler') {
        await this.resetListData()
        await this.listCustomer()
      } else {
        await this.resetListDataCustomerGlobal()
        await this.listCustomerGlobal()
      }
    },

    // search
    async search() {
      window.scrollTo(0, 0)

      // await this.$store.commit("filterGlobalModule/resetFilterItem")
      // this.resetFilter()
      this.customerData.data = []
      this.customerData.lengthData = 0
      this.searchKey.key = ""
      await this.$store.commit("customerModule/setIsSearchCustomer", true)
      await this.resetListData()
    },
    async loadingSearch(loading) {
      if (!loading) {
        if (this.nav.selected === 'reguler') {
          this.customerData.data = []
          this.customerData.lengthData = 0
        } else {
          this.customerGlobalData.data = []
          this.customerGlobalData.lengthData = 0
        }
      }
      this.pageSetting.search.waiting = loading
      this.pageSetting.loading.list = loading
    },
    async closeSearch() {
      this.pageSetting.loading.list = true

      // await this.$store.commit("filterGlobalModule/resetFilterItem")
      // this.resetFilter()
      await this.$store.commit("customerModule/setIsSearchCustomer", false)
      await this.$store.commit("customerModule/resetSearch")
      await this.resetListData()
      await this.listCustomer()
      this.pageSetting.loading.list = false
    },

    // search snapclean
    async searchCustomerGlobal() {
      window.scrollTo(0, 0)

      // await this.$store.commit("filterGlobalModule/resetFilterItem")
      // this.resetFilter()
      this.customerGlobalData.data = []
      this.customerGlobalData.lengthData = 0
      this.searchKey.key = ""
      await this.$store.commit("customerGlobalModule/setIsSearchCustomerGlobal", true)
      await this.resetListDataCustomerGlobal()
    },
    async closeSearchCustomerGlobal() {
      this.pageSetting.loading.list = true

      // await this.$store.commit("filterGlobalModule/resetFilterItem")
      // this.resetFilter()
      await this.$store.commit("customerGlobalModule/setIsSearchCustomerGlobal", false)
      await this.$store.commit("customerGlobalModule/resetSearch")
      await this.resetListDataCustomerGlobal()
      await this.listCustomerGlobal()
      this.pageSetting.loading.list = false
    },

    // reset
    async resetListData() {
      if (this.customerData.data !== undefined) {
        this.customerData.data = []
      }
      // await this.$store.commit("customerModule/resetSearch")
      await this.$store.commit("customerModule/resetPagination")
      await this.$store.commit("customerModule/resetCustomer")
    },
    async resetListDataCustomerGlobal() {
      if (this.customerGlobalData.data !== undefined) {
        this.customerGlobalData.data = []
      }
      // await this.$store.commit("customerGlobalModule/resetSearch")
      await this.$store.commit("customerGlobalModule/resetPagination")
      await this.$store.commit("customerGlobalModule/resetCustomerGlobal")
    },

    async flushDataCustomer() {
      await this.$store.commit("customerModule/resetPagination")
      await this.$store.commit("customerModule/resetCustomer")

      await this.$store.commit("customerGlobalModule/resetPagination")
      await this.$store.commit("customerGlobalModule/resetCustomerGlobal")
      await this.$store.commit("customerModule/resetSearch")
      await this.$store.commit("customerModule/setIsSearchCustomer", false)
    }
  },
  // beforeDestroy() {
  // 	this.$store.commit("customerModule/resetPagination")
  // 	this.$store.commit("customerModule/resetCustomer")
  //
  // 	this.$store.commit("customerGlobalModule/resetPagination")
  // 	this.$store.commit("customerGlobalModule/resetCustomerGlobal")
  // }
}
</script>